import { Flex, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { InfoIcon } from "../../icons/reader/InfoIcon";
import { ClaimWithGoldButton } from "../../cards/ClaimWithGoldButton";

/**
 * Replacement for `<CollectibleIndicator />` shown inside the purchase-release
 * modal when the release is currently a claimable Gold-monthly reward. Same
 * visual shape (icon + text), with an inline Claim button so the user has a
 * direct affordance to leave the modal and head to the rewards hub.
 */
export function ClaimableMonthlyIndicator({
  onBeforeNavigate,
}: {
  onBeforeNavigate?: () => void;
}) {
  return (
    <Flex
      flexDirection="column"
      gap="12px"
      alignSelf="center"
      alignItems="center"
    >
      <Flex flexDirection="row" gap="8px" alignItems="center">
        <InfoIcon boxSize="24px" color="neutral.400" />
        <Text
          color="neutral.400"
          fontSize="12px"
          lineHeight="150%"
          letterSpacing="0px"
          textAlign="center"
        >
          {t("components.payments.purchaseRelease.claimableMonthlyReward")}
        </Text>
      </Flex>
      <ClaimWithGoldButton onBeforeNavigate={onBeforeNavigate} />
    </Flex>
  );
}
